export default {
    'export': 'تصدير',
    'export-as-excel': 'تصدير إكسل',
    'print-journal-table': 'طباعة جدول اليومية',
    'search-within-caption': 'بحث ضمن الشرح',
    'from-date': 'من تاريخ',
    'to-date': 'إلى تاريخ',
    'only-debit-entries': 'قيود المدين فقط',
    search: 'بحث',
    cancel: 'إلغاء',

    'sum-result-headers': {
        'sum-debits': 'مجموع مدين',
        'sum-credits': 'مجموع دائن',
        difference: 'الفرق',
        'equivalent-currency': 'عملة مكافئة',
        'currency-equivalent': 'الرصيد بعملة مختلفة',
    },
    
    'sum-currencies-result-headers': {
        'currency-debits': 'عملات مدينة',
        'currency-credits': 'عملات دائنة',
    },
    
    headers: {
        'bond-no': 'رقم السند',
        sequence: 'تسلسل',
        account: 'الحساب',
        'account-no': 'رقم الحساب',
        debit: 'المدين',
        credit: 'الدائن',
        note: 'البيان',
        currency: 'العملة',
        'currency-debit': 'ع.مدينة',
        'currency-credit': 'ع.دائنة',
        price: 'السعر',
        'paper-document-no': 'م.الورقي',
        date: 'التاريخ',
    },
    
    'details-depending-on-currencies' : 'المجموع مفصلاً حسب العملات',
}